module.exports = __webpack_public_path__ + "static/media/Pending.9abb1cd3.svg";